import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { IconX } from '@tabler/icons-react'
import { _showToast } from "../../../../../toastHelper";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const People = forwardRef(
  function People(props, ref) {
    const [name, setName] = useState("");
    const [isOpen, setIsOpen] = useState("");
    const [relationship, setRelationship] = useState("");
    const [imageKey, setImageKey] = useState(null);
    const [errors, setErrors] = useState({});
    const imageRef = useRef();

    useEffect(() => {
      if (props.data) {
        setName(props.data.name);
        setIsOpen(props.data.show);
        setRelationship(props.data.relationship);
        setImageKey(props.data.imageKey);

        imageRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
        imageRef?.current?.setFileContent(props.data.imageFile);
      }
    }, [props.data])

    useEffect(() => {
      setIsOpen(props.data.show);
    }, [props.data.show]);


    const validate = () => {
      const errors = {};

      if (!name || (name && name.trim() == "")) {
        errors.name = "Name is required";
      }

      if (!relationship || (relationship && relationship.trim() == "")) {
        errors.relationship = "Relationship is required";
      }

      setErrors(errors);
      return Object.keys(errors).length === 0;
    }

    const getData = () => {
      return {
        name: name,
        relationship: relationship,
        image: imageRef?.current?.getThumbnail() ?? null,
        imageFile: imageRef?.current?.getImageFile() ?? null,
        imageKey: imageKey
      }
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
      <div className="card accordion-item ">
        <h2 className="accordion-header">
          <button type="button"
            onClick={() => props.showHidePople(props.index)}
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}>
            {name}
          </button>
        </h2>

        <div className={`accordion-collapse ${isOpen ? "show" : "collapse"}`}>
          <div className="accordion-body mt-3">
            <form>
              <div className="row">

                <div className="col-md-6 mt-2">
                  <label className="form-label required">
                    Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                    placeholder="Enter name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  {errors.title && (
                    <div className="invalid-feedback">
                      {errors.name}
                    </div>
                  )}
                </div>
                <div className="col-md-6 mt-2">
                  <label className="form-label required">
                    Relationship
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.relationship ? "is-invalid" : ""}`}
                    placeholder="Enter relationship"
                    value={relationship}
                    onChange={(e) => setRelationship(e.target.value)}
                  />
                  {errors.relationship && (
                    <div className="invalid-feedback">
                      {errors.relationship}
                    </div>
                  )}
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-sm-6">
                  <label className="form-label" htmlFor="image">
                    Image <small className="text-gray">(Max Allowable File Size: 1MB,Image Dimensions: 750px x 750px)</small>
                  </label>
                  <ImageBrowse elementId={"peopleImage-" + props.index} ref={imageRef} imageType="profile"
                    imageKey={imageKey} setImageKey={setImageKey} imageDelete={props.imageDelete} />
                </div>
              </div>
              <div className="col-12 mt-3">
                <button type="button" className="btn btn-label-danger"
                  onClick={() => props.deletePeople(props.index)}>
                  <IconX className="me-1" size={16} />
                  <span className="align-middle">Delete</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  });

export default People;
